import { razorpay } from "@/lib/razorpay";
import { theme } from "@chakra-ui/react";
import { options } from "joi";
const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL;

interface createdAdresponse {
  message: string;
  order: {
    id: string;
    amount: number;
    currency: string;
  };
  ad: any;
  key: string;
}
interface AdInfo {
  type: "promoted" | "homepage" | "story";
  startDate: string;
  endDate: string;
  status: "active" | "rejected" | "expired" | "pending";
  ownerId: string;
  businessId: string;
  images?: string[];
}
export const insertAdvertisementApi = async (
  adInfo: AdInfo
): Promise<createdAdresponse> => {
  const res = await fetch(
    `${BASE_URL}/advertisement/businessesads/${adInfo.businessId}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(adInfo),
    }
  );

  const result = await res.json();
  if (!res.ok) throw new Error(result.error || "Advertisement creation failed");

  return result as createdAdresponse;
};
export const createAdAndPay = async (adInfo: AdInfo) => {
  try {
    // Create ad with Razorpay order
    const { order, ad, key } = await insertAdvertisementApi(adInfo);

    //Setup Razorpay checkout options
    const options = {
      key,
      amount: order.amount,
      currency: order.currency,
      name: "Business Advertisement",
      description: `Payment for ${ad.type ?? "advertisement"} advertisement`,
      order_id: order.id,
      handler: async function (response: any) {
        // Verify payment on backend
        await fetch(`${BASE_URL}/api/payment/verify`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(response),
        });

        alert(" Payment successful and Ad activated!");
      },
      theme: {
        color: "#3399cc",
      },
    };

    // Open Razorpay
    const razorpay = new window.Razorpay(options);
    razorpay.open();
  } catch (error: any) {
    console.error("Error creating ad/payment:", error);
    alert(error.message || "Something went wrong while creating the ad");
  }
};

export const fetchAdvertisementsByStatusandBizId = async (
  status: string,
  businessId: string,
  type?: string
) => {
  try {
    const res = await fetch(
      `${BASE_URL}/advertisement/fetchadbystatusandbizid/${businessId}`,
      {
        method: "POST",
        cache: "no-store",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ status, type }),
      }
    );

    const result = await res.json();
    if (!res.ok) {
      throw new Error(result.error || "Failed to fetch advertisements");
    }
    return result.data;
  } catch (error) {
    console.error(
      "Error fetching advertisements by status and businessid:",
      error
    );
    throw error;
  }
};

export const fetchAdvertisementsByStatus = async (
  status?: string,
  page = 1,
  limit?: number
) => {
  try {
    const queryParams = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });

    const res = await fetch(
      `${BASE_URL}/advertisement?${queryParams.toString()}`,
      {
        method: "POST",
        cache: "no-store",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ status }),
      }
    );

    const results = await res.json();

    if (!res.ok) {
      throw new Error(results.error || "Failed to fetch ads");
    }

    return results;
  } catch (err) {
    console.error("Fetch advertisements error:", err);
    throw err;
  }
};

export const fetchAdvertisementsAdId = async (advertisementId: string) => {
  try {
    const response = await fetch(
      `${BASE_URL}/advertisement/advertisementbyadid/${advertisementId}`,
      {
        method: "GET",
      }
    );
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || "Failed to fetch single advertisement");
    }
    return data.data;
  } catch (error) {
    console.error("Error fetching advertisement:", error);
    throw error;
  }
};

export const deleteAdvertisementApi = async (advertisementId: string) => {
  try {
    const res = await fetch(
      `${BASE_URL}/advertisement/advertisementbyadid/${advertisementId}`,
      {
        method: "DELETE",
        cache: "no-store",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const result = await res.json();
    if (!res.ok) {
      throw new Error(result.error || "Failed to delete advertisement");
    }
  } catch (error) {
    console.error("Delete API Error:", error);
    throw error;
  }
};

export const updateAdvertisementStatus = async (
  advertisementId: string,
  status: string
) => {
  try {
    const res = await fetch(
      `${BASE_URL}/advertisement/adstatus/${advertisementId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ status }),
      }
    );

    const result = await res.json();
    if (!res.ok) {
      throw new Error(result.error || "Failed to update status");
    }

    return result;
  } catch (err) {
    console.error("Error updating advertisement status:", err);
    throw err;
  }
};

export const updatePendingAd = async (
  advertisementId: string,
  updateData: {
    type: string;
    startDate: Date;
    endDate: Date;
    price: number;
  }
) => {
  try {
    const res = await fetch(
      `${BASE_URL}/advertisement/advertisementbyadid/${advertisementId}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(updateData),
      }
    );

    const result = await res.json();
    if (!res.ok) throw new Error(result.error || "Update failed");
    // const { order, ad, key } = result;
    //setting up razorpay cheackout options

    // const options = {
    //   key,
    //   amount: order.amount,
    //   currency: order.currency,
    //   name: "Business Advertisement Updation",
    //   description: `Payment for update ${ad.type}`,
    //   order_id: order.id,
    //   handler: async function (response: any) {
    //     //verify payment backend
    //     await fetch(`${BASE_URL}/payment/verify`, {
    //       method: "POST",
    //       headers: { "Content-Type": "application/json" },
    //       body: JSON.stringify(response),
    //     });

    //     alert("Payment successful and ad activated!");
    //   },
    //   theme: {
    //     color: "#3399cc",
    //   },
    // };
    // //open razorpay checkout
    // const razorPay = new (window as any).Razorpay(options);
    // razorPay.open();
    return result.data;
  } catch (error) {
    console.error("Update Ad/payment Error:", error);
    throw error;
  }
};

export const updateAdImagesOnly = async (
  advertisementId: string,
  imageFiles: string[]
) => {
  try {
    const formData = new FormData();

    imageFiles.forEach((url) => {
      formData.append("images", url);
    });

    const res = await fetch(
      `${BASE_URL}/advertisement/editadimage/${advertisementId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ images: imageFiles }),
      }
    );

    const result = await res.json();

    if (!res.ok) throw new Error(result.error || "Image update failed");

    return result.data;
  } catch (error) {
    console.error("Image Update Error:", error);
    throw error;
  }
};

export const checkAdExpiry = async () => {
  try {
    const res = await fetch(`${BASE_URL}/advertisement/expiredad`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const result = await res.json();

    if (!res.ok) {
      throw new Error(result.error || "Failed to ad expiry");
    }

    return result;
  } catch (error: any) {
    console.error("Ad Expiry Error:", error.message || error);
    throw error;
  }
};
export const deleteAdvertiseImage = async (
  advertisementId: string,
  images: { fileId: string; url: string }
) => {
  try {
    const res = await fetch(
      `${BASE_URL}/advertisement/editadimage/${advertisementId}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(images),
      }
    );

    const result = await res.json();

    if (!res.ok) {
      throw new Error(result.error || "Failed to delete advertisement image");
    }

    return result;
  } catch (error) {
    console.error("Error advertisement image", error);
    throw error;
  }
};

export const businessRelevantAds = async (businessId: string) => {
  try {
    console.log("------api", businessId);
    const res = await fetch(
      `${BASE_URL}/business/getrelevantads/?businessId=${businessId}`,
      {
        method: "GET",
      }
    );

    const result = await res.json();

    if (!res.ok) {
      throw new Error(
        result.error || "Failed to get advertisement for business"
      );
    }

    return result;
  } catch (error) {
    console.error("Error advertisement for busines", error);
    throw error;
  }
};
